export const DeviceType = {
    mobile: 'mobile',
    desktop: 'desktop'
} as const

export const OSType = {
    android: 'android',
    ios: 'ios',
    unknown: 'unknown'
} as const

export const Methods = {
    p2pSbp: 'p2pSbp',
    p2pCard: 'p2pCard',
    p2pAccount: 'p2pAccount',
    p2pQr: 'p2pQr'
} as const

export const bankKeys = {
    sberbank: 'sberbank',
    tinkoff: 'tinkoff',
    alfa: 'alfa',
    vtb: 'vtb',
    raiffeisen: 'raiffeisen',
    gazprom: 'gazprom'
} as const

export const SberbankAndroidMethodDeeplinkMap = {
    [Methods.p2pSbp]: ['intent://ru.sberbankmobile/payments/p2p?type=phone_number&requisiteNumber={phoneNumber}'],
    [Methods.p2pCard]: ['intent://ru.sberbankmobile/payments/p2p?type=card_number&requisiteNumber={cardNumber}'],
    [Methods.p2pAccount]: ['intent://ru.sberbankmobile/payments/p2p?type=account_number&requisiteNumber={accountNumber}']
}

const TbankAndroidMethodDeeplinkMap = {
    [Methods.p2pSbp]: ['tbank://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer'],
    [Methods.p2pCard]: ['tbank://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}']
}

const TbankIosMethodDeeplinkMap  = {
    [Methods.p2pSbp]: [
        'tbank://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'mobtrs://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'tinkoffbank://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'feedaways://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'toffice://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'tguard://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'shuttersmart://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'petraise://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'goaloriented://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'tmydocs://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'tfinstudy://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'tsplit://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
        'tfinskills://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer'
    ],
    [Methods.p2pCard]: [
        'tbank://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'mobtrs://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'tinkoffbank://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'feedaways://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'toffice://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'tguard://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'shuttersmart://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'petraise://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'goaloriented://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'tmydocs://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'tfinstudy://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'tsplit://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
        'tfinskills://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}'
    ]
}

export const BankSystemDeeplinksMap = {
    [bankKeys.sberbank]: {
        [OSType.android]: SberbankAndroidMethodDeeplinkMap
    },
    [bankKeys.tinkoff]: {
        [OSType.android]: TbankAndroidMethodDeeplinkMap,
        [OSType.ios]: TbankIosMethodDeeplinkMap
    }
}

// tg://resolve?domain=flowernaru

export const SBP_SBERPAY_IOS_DEEPLINKS = [
    {
        app_name: 'Онлайн',
        deeplink: 'btripsexpenses://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone'
    },
    {
        app_name: 'Бюджет Онлайн',
        deeplink: 'budgetonline-ios://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone'
    },
    {
        app_name: 'СБОЛ',
        deeplink: 'sbolidexternallogin://p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone'
    },
    {
        app_name: 'Умный Онлайн',
        deeplink: 'ios-app-smartonline://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone'
    }
]

export const ACCOUNT_IOS_DEEPLINKS = [
    {
        app_name: 'Онлайн',
        deeplink: 'btripsexpenses://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account'
    },
    {
        app_name: 'Бюджет Онлайн',
        deeplink: 'budgetonline-ios://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account'
    },
    {
        app_name: 'СБОЛ',
        deeplink: 'sbolidexternallogin://p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account'
    },
    {
        app_name: 'Умный Онлайн',
        deeplink: 'ios-app-smartonline://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account'
    }
]
